import $ from 'jquery'
import jstz from 'jstimezonedetect'
import { viewModalEvent } from 'application/ga_view_modal_event'

const $form = $('#header-sign-up-form')
const $submitFormButton = $('button[type="submit"]', $form)
const $link = $("a[data-open='create-account-overlay']")
const $signInLink = $('.popup-sign-in-link')
const signInUrl = $signInLink.attr('href')
const $createAccountForm = $('#header-sign-up-form');

let isViaBanner = false;

$link.off('click.signup').on('click.signup', function() {
  if ($(this).data('banner')) {
    isViaBanner = true
    let url  = SOPHIA.Routes.new_user_sessions_path({ redirect: SOPHIA.Routes.membership_profile_path() })
    $signInLink.attr('href', url)
  } else {
    $signInLink.attr('href', signInUrl)
    isViaBanner = false
  }

  const modal = '#create-account-overlay[data-reveal]'

  $(document).on('open.zf.reveal', modal, () => {
    viewModalEvent({})
    SOPHIA.formGA($createAccountForm, 'form_view');
  });

  $(document).on('closed.zf.reveal', modal, () => {
    SOPHIA.clickModalCloseForGA(false, modal)

    $(document).off('closed.zf.reveal', modal).off('open.zf.reveal', modal)
  })
});

$form.find('.user_time_zone').val(jstz.determine().name)

$submitFormButton.on('click', function(e) {
  e.preventDefault()

  var params = $form.serializeArray()

  const data = {
    url: $form.attr('action'),
    type: $form.attr('method'),
    dataType: 'json',
    data: params
  };

  const callbacks = {
    afterSuccess: function(response) {
      if (response.errors) {
        const errors = response.errors

        // fields errors
        $.each($('input[type="text"], input[type="password"]', $form), function(index, field) {
          const $field = $(field)
          const $fieldWrapper = $field.parents('.form-field')
          const fieldName = $field.attr('name')
          const errorsArray = Object.keys(errors).map((key) => ({name: key, error: errors[key]}))

          $.each(errorsArray, function(index, error) {
            let errorName = 'user[' + error.name + ']'
            let errorDescription = error.error
            let errorMessage = '<div class="form-field__errors">' + errorDescription[0] + '</div>';
            if (errorName == fieldName) {
              $('.form-field__errors', $fieldWrapper).remove()
              $fieldWrapper.addClass('field_with_errors').append(errorMessage);
            }
          })

          $field.on('keyup', () => {
              $fieldWrapper.removeClass('field_with_errors')
              $('.form-field__errors', $fieldWrapper).remove()
          })
        })
      } else {
        const formName = `partner - ${$form.data('partnerName')} - create account form`

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'formSubmission',
          formType: 'signup',
          formName: formName,
          email: data['data'].find(i => i.name === 'user[authentication_email]').value,
          fn: '',
          ln: ''
        })

        window.adobeDataLayer = window.adobeDataLayer || [];
        window.adobeDataLayer.push({
          event: 'formSubmission',
          eventInfo: {
            formData: {
              formType: 'signup',
              formName: formName
            }
          }
        })

        SOPHIA.formGA($form, 'form_submit')

        if (isViaBanner === true) {
          window.location = SOPHIA.Routes.membership_profile_path()
        } else {
          window.location.reload()
        }
      }
    }
  };

  SOPHIA.sendXHR(data, callbacks);
})
